export default __webpack_public_path__ + "static/media/gallery_03.fa01d9b7.jpg";